import { PHOTO_GROUPS, getPhotoGroupItems } from '../case-dentist/scanUploadConfig';
import { uploadScan, uploadPhoto } from './caseFileUploadService';

/**
 * @param {{ upperFile?: File, lowerFile?: File, caseId: string, patientId: string, currentUserId: string, onProgress?: (pct: number) => void }} p
 */
export async function uploadCaseStlScans(p) {
  const { upperFile, lowerFile, caseId, patientId, currentUserId, onProgress } = p;
  const tasks = [];

  if (upperFile) {
    tasks.push(
      uploadScan(upperFile, patientId, caseId, 'upper', currentUserId, { onProgress }).then(
        (result) => ({ type: 'upper', ...result })
      )
    );
  }
  if (lowerFile) {
    tasks.push(
      uploadScan(lowerFile, patientId, caseId, 'lower', currentUserId, { onProgress }).then(
        (result) => ({ type: 'lower', ...result })
      )
    );
  }

  return Promise.all(tasks);
}

/**
 * @param {{ photoFiles: Record<string, File>, caseId: string, patientId: string, currentUserId: string, onProgress?: (pct: number) => void }} p
 */
export async function uploadCaseClinicalPhotos(p) {
  const { photoFiles, caseId, patientId, currentUserId, onProgress } = p;
  const entries = Object.entries(photoFiles || {}).filter(([, file]) => !!file);

  await Promise.all(
    entries.map(async ([photoKey, file]) => {
      const group = PHOTO_GROUPS.find((g) =>
        getPhotoGroupItems(g).some((item) => item.key === photoKey)
      );
      const category = group?.id;
      if (!category) return;
      await uploadPhoto(file, patientId, caseId, photoKey, category, currentUserId, {
        onProgress,
      });
    })
  );

  return entries.length;
}
